riot.tag2('dealer-filter', '<div class="filter-container"> <a href="#" class="filter-select-link" onclick="{selectFilter}" data-tracking="{trackingDataFiltering}"> <div class="filter-select"> <acr-svg svg-id="checkmark" class="{\'is-selected\': filter.isSelected}" svg-class="acr-icon filter-checkmark-icon" svg-viewbox="0 0 26 26"></acr-svg> </div> <span class="filter-item-name acr-paragraph-5">{filter.title}</span> </a> <a class="filter-info-link" href="#" onclick="{showInfo}" data-tracking="{trackingDataFilteringInfo}"> <acr-svg svg-id="bap-info-icon" svg-class="acr-icon filter-info-icon" svg-viewbox="0 0 26 26"></acr-svg> <span class="filter-item-title">{filter.title}</span> <span class="filter-item-desc">{filter.description}</span> </a> </div>', '', 'class="filter-item {\'is-selected\': filter.isSelected}"', function(opts) {
    var self = this;
    var filterService = require('../../core/Filters.js');
    var trackingJSON = require('../../data/tracking-data');
    var jsonData = JSON.parse(JSON.stringify(trackingJSON.filteringByAwardAndServiceInfo));

    // Modifying tracking data with the item info
    jsonData.dynamic_variables[0].search += self.filter.title + ':info icon';

    // Assigning tracking data to a self prop to be accessible in the markup
    self.trackingDataFiltering = JSON.stringify(trackingJSON.filteringByAwardAndService);
    self.trackingDataFilteringInfo = JSON.stringify(jsonData);

    self.mixin('bus');

    function selectFilter() {
      var channel;

      self.filter.isSelected = !self.filter.isSelected;

      channel = (self.filter.isSelected)
        ? self.bus.EVENTS.FILTERS.SELECT : self.bus.EVENTS.FILTERS.UNSELECT;

      self.bus.trigger(channel,
        {
          codes: self.filter.codes,
        });
      self.update();
      self.parent.applyFilters();
    }

    function showInfo(event) {
      self.bus.trigger(self.bus.EVENTS.FILTERS.OPEN_TOOLTIP, event);
    }

    function resetFilter() {
      self.filter.isSelected = false;

      self.update();
    }

    function openFilter() {
      self.filter.isSelected = filterService.getFilter(self.filter.codes);

      self.update();
    }

/**
* @desc updates the filter item
*/
    function updateFilter() {
      self.update();
    }

    this.bus.on(this.bus.EVENTS.FILTERS.RESET, resetFilter);
    this.bus.on(this.bus.EVENTS.DEALERS.CLOSE_FILTER, openFilter);
    self.bus.on(self.bus.EVENTS.FILTERS.UPDATE, updateFilter);

    self.selectFilter = selectFilter;
    self.showInfo = showInfo;

});
